module.exports = __webpack_public_path__ + "img/0x8122bc2212ec971690a044b37a6f52a9349b702b.8346812f.png";